import _sfc_main from "./component-library170.mjs";
import "./component-library171.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "controls", class: { "controls--hide-pages": _vm.hidePages, "controls--hide-pages-mobile": _vm.hidePagesMobile } }, [_vm.hasPlayPause ? _c("div", { staticClass: "controls__play-pause" }, [_c(_setup.PlayPauseButton, { attrs: { "primary": _vm.primary, "secondary": _vm.secondary, "aria-label": _setup.internalIsPlaying ? `${_vm.playPauseAriaLabel} pausieren` : `${_vm.playPauseAriaLabel} abspielen` }, on: { "input": (args) => _vm.$emit("input", args) }, model: { value: _setup.internalIsPlaying, callback: function($$v) {
    _setup.internalIsPlaying = $$v;
  }, expression: "internalIsPlaying" } })], 1) : _vm._e(), _c(_setup.CarouselNavigation, { staticClass: "controls__pagination", attrs: { "pages": _vm.pages, "aria-label": _vm.paginationAriaLabel, "infinity": _vm.infinityScroll, "hide-pages": _vm.hidePages, "hide-pages-mobile": _vm.hidePagesMobile, "label-next": _vm.paginationNext, "label-prev": _vm.paginationPrev, "button-label": _vm.paginationButtonLabel, "button-label-first": _vm.paginationButtonLabelFirst, "button-label-last": _vm.paginationButtonLabelLast, "do-not-scroll-into-view": _vm.doNotScrollIntoView, "primary": _vm.primary, "secondary": _vm.secondary }, on: { "update": (args) => _vm.$emit("update", args) } }), _vm.hasPlayPause ? _c("div", { staticClass: "controls__spacer" }) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "184e8ce1",
  null,
  null
);
const Controls = __component__.exports;
export {
  Controls as default
};
